import { last } from 'lodash';

export const locationUrl = (location) => (last(location.geoPath) || {}).link;

export const locationAddress = (location) => {
  const [_, ...path] = (location.geoPath || []).map((p) => p.name); // eslint-disable-line no-unused-vars
  return path.reverse().join(', ');
};
